  import { CustomTieredUnique, Tier, TieredItem, UniqueTierType } from "../../models/item-data-models";

export const minimalCurrencyTierListData: TieredItem[] = [
  { name: "Breach Splinter", tier: Tier.EVisible },
  { name: "Simulacrum Splinter", tier: Tier.EVisible },

  { name: "Scroll of Wisdom", tier: Tier.EVisible }, // This makes sure that if you select not to hide them on the Quick Filters, they're shown
  { name: "Uncut Support Gem (Level 5)", tier: Tier.EVisible }, // Same

  // { name: "Expedition Tablet", tier: Tier.CYellow },
  { name: "Irradiated Tablet", tier: Tier.DWhite },
  { name: "Temple Tablet", tier: Tier.DWhite },
  { name: "Breach Tablet", tier: Tier.DWhite },
  { name: "Delirium Tablet", tier: Tier.DWhite },
  { name: "Ritual Tablet", tier: Tier.DWhite },
  { name: "Overseer Tablet", tier: Tier.DWhite },
  { name: "Abyss Tablet", tier: Tier.DWhite },

  { name: "Signet Wombgift", tier: Tier.EVisible },
  { name: "Banded Wombgift", tier: Tier.EVisible },
  { name: "Ornate Wombgift", tier: Tier.EVisible },
  { name: "Lavish Wombgift", tier: Tier.EVisible },
  { name: "Revelatory Wombgift", tier: Tier.EVisible },
];

export const minimalUniqueTierListData: CustomTieredUnique[] = [
  { baseType: "Irradiated Tablet", tier: "Potential" as UniqueTierType },
  { baseType: "Expedition Tablet", tier: "Potential" as UniqueTierType },
  { baseType: "Ritual Tablet", tier: "Potential" as UniqueTierType },
  { baseType: "Abyss Tablet", tier: "Potential" as UniqueTierType },
  { baseType: "Delirium Tablet", tier: "Potential" as UniqueTierType },
  { baseType: "Overseer Tablet", tier: "Potential" as UniqueTierType },
  { baseType: "Breach Tablet", tier: "Potential" as UniqueTierType },

  { baseType: "Abyssal Signet", tier: "Potential" as UniqueTierType },
  { baseType: "Ravenous Staff", tier: "Potential" as UniqueTierType },

  // { baseType: "Viper Cap", tier: "Good" as UniqueTierType },
  // { baseType: "Tribal Mask", tier: "Excellent" as UniqueTierType },
];
